import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=e45fdd42&scoped=true&"
import script from "./Burger.vue?vue&type=script&lang=js&"
export * from "./Burger.vue?vue&type=script&lang=js&"
import style0 from "./Burger.vue?vue&type=style&index=0&id=e45fdd42&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fburger&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45fdd42",
  null
  
)

export default component.exports